// デザインシステムの CSS（pack CSS として出力され、stylesheet_pack_tag で配信される）
import '@/ui/styles.css';
import 'bootstrap';
import $ from 'jquery';
import ReactOnRails from 'react-on-rails';
// @ts-expect-error モジュール 'ahoy.js' に型定義が無いため
import ahoy from 'ahoy.js';
// @ts-expect-error モジュール '@rails/ujs' に型定義が無いため
import RailsUjs from '@rails/ujs';
// @ts-expect-error モジュール '@hotwired/turbo' に型定義が無いため
import * as Turbo from '@hotwired/turbo';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import '../config/sentry';
import 'slick-carousel';
import 'chart.js/auto';
import flashMessage from '../common/utils/flashMessage';

interface Window {
  jQuery: JQueryStatic;
  $: JQueryStatic;
  views: Record<string, unknown>;
  notify: (
    title: string,
    message: string,
    from: string,
    align: string,
    icon: string,
    type: string,
    animIn: string,
    animOut: string,
  ) => void;
}

declare let window: Window;

window.jQuery = $;
window.$ = $;
window.notify = flashMessage;

// Rails
RailsUjs.start();
Turbo.session.drive = false;

// JQuery plugins
import 'bootstrap-notify';
import 'tempusdominus-bootstrap-4';
import 'jquery-jpostal-ja';

// summernote
import 'summernote/dist/summernote-bs4';
import 'summernote/lang/summernote-ja-JP';

// JQuery views
import ViewsCommonOtpView from '../application/views/common/otpView';
import ViewsLayoutsBundleView from '../application/views/layouts/bundleView';
import ViewsLayoutsPolicyReconsentModalView from '../application/views/layouts/policyReconsentModalView';
import ViewsLayoutsRenewSpecificModalView from '../application/views/layouts/renewSpecificModalView';
import ViewsMyUsersFormView from '../application/views/my/users/formView';
import ViewsMyCompaniesBasicsFormView from '../application/views/my/companies/basics/formView';
import ViewsMyCompaniesIrsFormView from '../application/views/my/companies/irs/formView';
import ViewsMyCompaniesIrsEditorView from '../application/views/my/companies/irs/editorView';
import ViewsMyCompaniesIrsTemplateView from '../application/views/my/companies/irs/templateView';
import ViewsMyCompaniesIrsOnlineMeetingView from '../application/views/my/companies/irs/onlineMeetingView';
import ViewsMyCompaniesIrsOnlineVotingView from '../application/views/my/companies/irs/onlineVotingView';
import ViewsMyCompaniesFundingAgreementsFormView from '../application/views/my/companies/funding/agreements/formView';
import ViewsMyInvestorsFormView from '../application/views/my/investors/formView';
import ViewsMyInvestorsInterviewsFormView from '../application/views/my/investors/interviews/formView';
import ViewsMyInvestorsCorporatesFormView from '../application/views/my/investors/corporates/formView';
import ViewsMyInvestorsBeneficialOwnersFormView from '../application/views/my/investors/beneficial_owners/formView';
import ViewsMyInvestorsTransactionPeopleFormView from '../application/views/my/investors/transaction_people/formView';
import ViewsMyInvestorsCorporateDocumentsFormView from '../application/views/my/investors/corporate_documents/formView';
import ViewsMyInvestorsSpecificApplicationsFormView from '../application/views/my/investors/specific_applications/formView';
import ViewsInvestorsSpecificApplicationsUsersFormView from '../common/views/investors/specific_applications/users/formView';
import ViewsInvestorsSpecificApplicationsUsersSelectPatternView from '../common/views/investors/specific_applications/users/selectPatternView';
import ViewsInvestorsSpecificApplicationsUsersFileUploadView from '../common/views/investors/specific_applications/users/fileUploadView';
import ViewsMyInvestorsSpecificApplicationsUsersFileUploadRenewView from '../application/views/my/investors/specific_applications/users/fileUploadRenewView';
import ViewsMyInvestorsSpecificApplicationsUsersConfirmView from '../application/views/my/investors/specific_applications/users/confirmView';
import ViewsMyInvestorsSpecificApplicationsUsersRenewalConfirmView from '../application/views/my/investors/specific_applications/users/renewalConfirmView';
import ViewsInvestorsSpecificApplicationsCorporatesFormView from '../common/views/investors/specific_applications/corporates/formView';
import ViewsInvestorsSpecificApplicationsCorporatesSelectPatternView from '../common/views/investors/specific_applications/corporates/selectPatternView';
import ViewsInvestorsSpecificApplicationsCorporatesFileUploadView from '../common/views/investors/specific_applications/corporates/fileUploadView';
import ViewsMyInvestorsSpecificApplicationsCorporatesConfirmView from '../application/views/my/investors/specific_applications/corporates/confirmView';
import ViewsMyInvestorsSpecificApplicationsCorporatesRenewalConfirmView from '../application/views/my/investors/specific_applications/corporates/renewalConfirmView';
import ViewsMyInvestorsOrdersMediaView from '../application/views/my/investors/orders/mediaView';
import ViewsMyInvestorsOrdersCancelReasonsFormView from '../application/views/my/investors/orders/cancel_reasons/formView';
import ViewsMyInvestorsReportsIndexView from '../application/views/my/investors/reports/indexView';
import ViewsMyInvestorsPepsFormView from '../application/views/my/investors/peps/formView';
import ViewsMyInvestorsIrsIndexView from '../application/views/my/investors/irs/indexView';
import ViewsMyInvestorsIrsSearchView from '../application/views/my/investors/irs/searchView';
import ViewsMyInvestorsAnnualReportsIndexView from '../application/views/my/investors/annual_reports/indexView';
import ViewsMyInvestorsWizardBeneficialOwnersShowView from '../application/views/my/investors/wizard/beneficial_owners/showView';
import ViewsMyInvestorsWizardUserIndividualsFormView from '../application/views/my/investors/wizard/user_individuals/formView';
import ViewsMyInvestorsTradesIndexView from '../application/views/my/investors/trades/indexView';
import ViewsMyInvestorsWizardUserIndividualsAgreementFormView from '../application/views/my/investors/wizard/user_individuals/agreementFormView';
import ViewsMyIdentificationsFormView from '../application/views/my/identifications/formView';
import ViewsMyIdentificationsEkycView from '../application/views/my/identifications/ekycView';
import ViewsMyIdentificationsPreView from '../application/views/my/identifications/preView';
import ViewsMyIdentificationsIndividualsFormView from '../application/views/my/identifications/individuals/formView';
import ViewsMyPasswordsShowView from '../application/views/my/passwords/showView';
import ViewsCmsContentsShowView from '../application/views/cms_contents/showView';
import ViewsCompaniesGeneralMeetingsVotesShowView from '../application/views/companies/general_meetings/votes/showView';
import ViewsCompaniesStockExchangesStockTransfersFormView from '../application/views/companies/stock_exchanges/stock_transfers/formView';
import ViewsCompayContactsFormView from '../application/views/compay_contacts/formView';
import ViewsContactsFormView from '../application/views/contacts/formView';
import ViewsProjectsShowView from '../application/views/projects/showView';
import ViewsProjectsV0ShowView from '../application/views/projects/v0/showView';
import ViewsProjectsProductsOrdersContractsShowView from '../application/views/projects/products/orders/contracts/showView';
import ViewsPlusInvestorContactView from '../application/views/plus/investorContactView';
import ViewsPlusPlusProjectsShowView from '../application/views/plus/plus_projects/showView';
import ViewsPlusProjectsFormView from '../application/views/plus_projects/formView';
import ViewsQuitsFormView from '../application/views/quits/formView';
import ViewsUsersRegistrationsFormView from '../application/views/users/registrations/formView';
import ViewsUsersSessionsFormView from '../application/views/users/sessions/formView';
import ViewsPagesFundingView from '../application/views/pages/fundingView';
import ViewsPagesUserGuideView from '../application/views/pages/userGuideView';
import ViewsPagesCampaignView from '../application/views/pages/campaignView';
import ViewsPagesStatsView from '../application/views/pages/statsView';
import ViewsPagesAboutShareholderCommunityView from '../application/views/pages/aboutShareholderCommunityView';
import ViewsPagesAboutPageView from '../application/views/pages/aboutPageView';
import ViewsPagesAboutCompanyPageView from '../application/views/pages/aboutCompanyPageView';
import ViewsAboutCompanyCasesCaseShowView from '../application/views/about_company/cases/caseShowView';
import ViewsShareholderCommunitiesIndexView from '../application/views/shareholder_communities/indexView';
import ViewsShareholderCommunitiesShowView from '../application/views/shareholder_communities/showView';
import ViewsShareholderCommunitiesTypeRatio from '../application/views/shareholder_communities/typeRatio';
import ViewsShareholderCommunitiesLeavesShowView from '../application/views/shareholder_communities/leaves/showView';
import ViewsShareholderCommunitiesTradesFormView from '../application/views/shareholder_communities/trades/formView';
import ViewsWhitePapersDownloadsFormView from '../application/views/white_papers/downloads/formView';
import ViewsLpsFundraisingSimsShowView from '../application/views/lps/fundraising_sims/showView';
import ViewsLpsPageView from '../application/views/lps/pageView';
import ViewsSharedCampaignFloatingBannerView from '../application/views/shared/campaignFloatingBannerView';

// React components for ReactOnRails
import ViewsCompaniesIndexView from '../application/views/companies/indexView';
import ViewsMyInvestorsBankView from '../application/views/my/investors/bankView';
import ViewsProjectsIndexView from '../application/views/projects/indexView';
import ViewsQuestionsAngelTaxView from '../application/views/questions/angelTaxView';
import ViewsMyCompaniesKyccsCompaniesShowView from '../application/views/my/companies/kyccs/companies/showView';
import ViewsMyCompaniesKyccsCustomersShowView from '../application/views/my/companies/kyccs/customers/showView';
import ViewsMyInvestorsSpecificApplicationsFileUploadView from '../common/views/investors/specific_applications/fileUploadView';
import ViewsMyInvestorsDemandQuestionairesSelectCompaniesToSellView from '../application/views/my/investors/shareholder_communities/demand_questionnaires/selectCompaniesToSellView';
import ViewsMyInvestorsDemandQuestionairesSelectCompaniesToBuyView from '../application/views/my/investors/shareholder_communities/demand_questionnaires/selectCompaniesToBuyView';
import ViewsMyInvestorsDemandQuestionairesInputOtherVentureCompaniesView from '../application/views/my/investors/shareholder_communities/demand_questionnaires/inputOtherVentureCompaniesView';
import ViewsMyinvestorsWizardUserIndividualsBankView from '../application/views/my/investors/wizard/user_individuals/bankView';
import ViewsLpsFundraisingSimsPageView from '../application/views/lps/fundraising_sims/pageView';
import ViewsLpsFundraisingSimsSimulatorView from '../application/views/lps/fundraising_sims/SimulatorView';
import ViewsLpsAngeltaxType3SimulatorView from '../application/views/lps/angeltax_type3/simulatorView';
import ViewsPlusInvestorContactFormView from '../application/views/plus/investorContactFormView';
import ViewsPlusPlusProjectsIndexView from '../application/views/plus/plus_projects/indexView';

ahoy.trackAll();

window.views = {
  common: {
    OtpView: ViewsCommonOtpView,
  },
  layouts: {
    BundleView: ViewsLayoutsBundleView,
    PolicyReconsentModalView: ViewsLayoutsPolicyReconsentModalView,
    RenewSpecificModalView: ViewsLayoutsRenewSpecificModalView,
  },
  my: {
    users: {
      FormView: ViewsMyUsersFormView,
    },
    companies: {
      basics: {
        FormView: ViewsMyCompaniesBasicsFormView,
      },
      irs: {
        FormView: ViewsMyCompaniesIrsFormView,
        EditorView: ViewsMyCompaniesIrsEditorView,
        TemplateView: ViewsMyCompaniesIrsTemplateView,
        OnlineMeetingView: ViewsMyCompaniesIrsOnlineMeetingView,
        OnlineVotingView: ViewsMyCompaniesIrsOnlineVotingView,
      },
      funding: {
        agreements: {
          FormView: ViewsMyCompaniesFundingAgreementsFormView,
        },
      },
    },
    investors: {
      FormView: ViewsMyInvestorsFormView,
      interviews: {
        FormView: ViewsMyInvestorsInterviewsFormView,
      },
      corporates: {
        FormView: ViewsMyInvestorsCorporatesFormView,
      },
      beneficial_owners: {
        FormView: ViewsMyInvestorsBeneficialOwnersFormView,
      },
      transaction_people: {
        FormView: ViewsMyInvestorsTransactionPeopleFormView,
      },
      corporate_documents: {
        FormView: ViewsMyInvestorsCorporateDocumentsFormView,
      },
      specific_applications: {
        FormView: ViewsMyInvestorsSpecificApplicationsFormView,
        users: {
          FormView: ViewsInvestorsSpecificApplicationsUsersFormView,
          SelectPatternView:
            ViewsInvestorsSpecificApplicationsUsersSelectPatternView,
          FileUploadView: ViewsInvestorsSpecificApplicationsUsersFileUploadView,
          FileUploadRenewView:
            ViewsMyInvestorsSpecificApplicationsUsersFileUploadRenewView,
          ConfirmView: ViewsMyInvestorsSpecificApplicationsUsersConfirmView,
          RenewalConfirmView:
            ViewsMyInvestorsSpecificApplicationsUsersRenewalConfirmView,
        },
        corporates: {
          FormView: ViewsInvestorsSpecificApplicationsCorporatesFormView,
          SelectPatternView:
            ViewsInvestorsSpecificApplicationsCorporatesSelectPatternView,
          FileUploadView:
            ViewsInvestorsSpecificApplicationsCorporatesFileUploadView,
          ConfirmView:
            ViewsMyInvestorsSpecificApplicationsCorporatesConfirmView,
          RenewalConfirmView:
            ViewsMyInvestorsSpecificApplicationsCorporatesRenewalConfirmView,
        },
      },
      orders: {
        MediaView: ViewsMyInvestorsOrdersMediaView,
        cancel_reasons: {
          FormView: ViewsMyInvestorsOrdersCancelReasonsFormView,
        },
      },
      reports: {
        IndexView: ViewsMyInvestorsReportsIndexView,
      },
      peps: {
        FormView: ViewsMyInvestorsPepsFormView,
      },
      irs: {
        IndexView: ViewsMyInvestorsIrsIndexView,
        SearchView: ViewsMyInvestorsIrsSearchView,
      },
      annual_reports: {
        IndexView: ViewsMyInvestorsAnnualReportsIndexView,
      },
      wizard: {
        beneficial_owners: {
          ShowView: ViewsMyInvestorsWizardBeneficialOwnersShowView,
        },
        user_individuals: {
          FormView: ViewsMyInvestorsWizardUserIndividualsFormView,
        },
      },
      trades: {
        IndexView: ViewsMyInvestorsTradesIndexView,
      },
      user_individuals: {
        AgreementFormView:
          ViewsMyInvestorsWizardUserIndividualsAgreementFormView,
      },
    },
    identifications: {
      FormView: ViewsMyIdentificationsFormView,
      EkycView: ViewsMyIdentificationsEkycView,
      PreView: ViewsMyIdentificationsPreView,
      individuals: {
        FormView: ViewsMyIdentificationsIndividualsFormView,
      },
    },
    passwords: {
      ShowView: ViewsMyPasswordsShowView,
    },
  },
  cms_contents: {
    ShowView: ViewsCmsContentsShowView,
  },
  companies: {
    general_meetings: {
      votes: {
        ShowView: ViewsCompaniesGeneralMeetingsVotesShowView,
      },
    },
    stock_exchanges: {
      stock_transfers: {
        FormView: ViewsCompaniesStockExchangesStockTransfersFormView,
      },
    },
  },
  compay_contacts: {
    FormView: ViewsCompayContactsFormView,
  },
  contacts: {
    FormView: ViewsContactsFormView,
  },
  projects: {
    ShowView: ViewsProjectsShowView,
    v0: {
      ShowView: ViewsProjectsV0ShowView,
    },
    products: {
      orders: {
        contracts: {
          ShowView: ViewsProjectsProductsOrdersContractsShowView,
        },
      },
    },
  },
  plus: {
    InvestorContactView: ViewsPlusInvestorContactView,
    plus_projects: {
      ShowView: ViewsPlusPlusProjectsShowView,
    },
  },
  plus_projects: {
    FormView: ViewsPlusProjectsFormView,
  },
  quits: {
    FormView: ViewsQuitsFormView,
  },
  users: {
    registrations: {
      FormView: ViewsUsersRegistrationsFormView,
    },
    sessions: {
      FormView: ViewsUsersSessionsFormView,
    },
  },
  pages: {
    FundingView: ViewsPagesFundingView,
    UserGuideView: ViewsPagesUserGuideView,
    CampaignView: ViewsPagesCampaignView,
    StatsView: ViewsPagesStatsView,
    AboutShareholderCommunityView: ViewsPagesAboutShareholderCommunityView,
    AboutPageView: ViewsPagesAboutPageView,
    AboutCompanyPageView: ViewsPagesAboutCompanyPageView,
  },
  about_company: {
    cases: {
      CaseShowView: ViewsAboutCompanyCasesCaseShowView,
    },
  },
  shareholder_communities: {
    IndexView: ViewsShareholderCommunitiesIndexView,
    ShowView: ViewsShareholderCommunitiesShowView,
    TypeRatio: ViewsShareholderCommunitiesTypeRatio,
    leaves: {
      ShowView: ViewsShareholderCommunitiesLeavesShowView,
    },
    trades: {
      FormView: ViewsShareholderCommunitiesTradesFormView,
    },
  },
  white_papers: {
    downloads: {
      FormView: ViewsWhitePapersDownloadsFormView,
    },
  },
  shared: {
    CampaignFloatingBannerView: ViewsSharedCampaignFloatingBannerView,
  },
  lps: {
    fundraisingSims: {
      ShowView: ViewsLpsFundraisingSimsShowView,
    },
    PageView: ViewsLpsPageView,
  },
};

ReactOnRails.register({
  ViewsCompaniesIndexView,
  ViewsMyInvestorsBankView,
  ViewsProjectsIndexView,
  ViewsQuestionsAngelTaxView,
  ViewsMyCompaniesKyccsCompaniesShowView,
  ViewsMyCompaniesKyccsCustomersShowView,
  ViewsMyInvestorsSpecificApplicationsFileUploadView,
  ViewsMyInvestorsDemandQuestionairesSelectCompaniesToSellView,
  ViewsMyInvestorsDemandQuestionairesSelectCompaniesToBuyView,
  ViewsMyInvestorsDemandQuestionairesInputOtherVentureCompaniesView,
  ViewsMyinvestorsWizardUserIndividualsBankView,
  ViewsLpsFundraisingSimsPageView,
  ViewsLpsFundraisingSimsSimulatorView,
  ViewsLpsAngeltaxType3SimulatorView,
  ViewsPlusInvestorContactFormView,
  ViewsPlusPlusProjectsIndexView,
});
